import React from 'react';
import { Link } from 'react-router-dom';
import {
  formatNumberInThousands,
  getEncryptedOrDecryptedData,
} from '../../../../utils/functions';
import moment from 'moment';

// shifts the impressions column left, away from the left aligned date columns
const IMP_COUNT_OFFSET = '40px';
// the header keeps the table's default cell padding, so it needs less than the cells
const IMP_COUNT_HEADER_OFFSET = '22px';

export const createColumns = () => {
  return [
    {
      id: 'campaign_id',
      name: 'CAMPAIGN ID',
      selector: (row) => (
        <div className='tableCellFontStyle tableCampNameFontStyle'>
          <Link
            to={`/campaign/${
              row.campaign_id
            }?params=${getEncryptedOrDecryptedData(
              { name: row.campaign_name },
              'encrypt'
            )}`}
          >
            <div className='campaignNameStyleAC'>{row.campaign_id}</div>
          </Link>
        </div>
      ),
      sortable: true,
      sortField: 'campaign_id',
      width: '135px',
      right: true,
    },
    {
      id: 'campaign_name',
      name: 'CAMPAIGN NAME',
      selector: (row) => (
        <div className='tableCellFontStyle tableCampNameFontStyle'>
          <Link
            to={`/campaign/${
              row.campaign_id
            }?params=${getEncryptedOrDecryptedData(
              { name: row.campaign_name },
              'encrypt'
            )}`}
          >
            <div className='campaignNameStyleCL'>{row.campaign_name}</div>
          </Link>
        </div>
      ),
      sortable: true, // sorting
      sortField: 'campaign_name', // sorting
      minWidth: '150px !important',
    },
    {
      id: 'imp_count',
      name: (
        <div style={{ paddingRight: IMP_COUNT_HEADER_OFFSET }}>
          IMPRESSION TO DATE
        </div>
      ),
      selector: (row) => (
        <div className='tableCellFontStyle'>
          {formatNumberInThousands(row.imp_count || 0)}
        </div>
      ),
      sortable: true, // sorting
      sortField: 'imp_count', // sorting
      style: { justifyContent: 'flex-end', paddingRight: IMP_COUNT_OFFSET },
      width: `20%`,
      minWidth: '210px !important',
      right: true,
    },
    {
      id: 'start_date',
      name: 'STARTING',
      selector: (row) => {
        return (
          <div className='campaignListStartingWrapper'>
            <div className='tableCellFontStyle '>
              {moment.utc(row.start_date).format('MM/DD/YYYY')}
            </div>
          </div>
        );
      },
      sortable: true, // sorting
      sortField: 'start_date', // sorting
      width: '150px',
    },
    {
      id: 'end_date',
      name: 'ENDING',
      selector: (row) => {
        return (
          <div className='campaignListEndingWrapper'>
            <div className='tableCellFontStyle '>
              {moment.utc(row.end_date).format('MM/DD/YYYY')}
            </div>
          </div>
        );
      },
      sortable: true, // sorting
      sortField: 'end_date', // sorting
      width: '150px',
    },
    {
      id: 'runReportCL',
      name: 'RUN REPORT',
      selector: (row) => (
        <button
          className='runReportIcon runReportEndable'
          onClick={() =>
            window.open(
              `/reports/run/?rd1=${row.campaign_id}`,
              '_blank',
              'noreferrer'
            )
          }
        />
      ),
      sortable: false,
      style: { justifyContent: 'center' },
      width: '110px',
    },
  ];
};
